import Blockly from "blockly";
import Schema from "../schema";

import { menu as room__enemies } from './room_enemies';
import { menu as room__items } from './room_items';
import { menu as room__visual } from './room_visuals';
import { menu as room__misc } from './room_misc';
// import { menu as room__door } from './room_door';

export const menu = {
  name: (<div className="text"><u>R</u>oom</div>),
  trigger: 'r',
  children: {
    room__enemies,
    room__items,
    room__visual,
    ...room__misc,
    //    ...room__door
  }
}


/* ****************************************************************************************************************
 * Spawn an item or enemy in to the current room. Shared here as it is referenced in two dropdowns.
 ******************************************************************************************************************/
Blockly.Blocks['room_spawn'] = {
  init: function () {
    let shadow = this.workspace.newBlock('default_room_spawn');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck([
        'active',
        'boss',
        'card',
        'collectible',
        'enemy',
        'spawnable',
        'monster',
        'modifier_count',
        'passive',
        'pill',
        'trinket'
      ])
      .appendField('Spawn')
      .connection
      .connect(shadow.outputConnection);
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Spawns the specified entity in the current room. Data must be one of Card, Collectible, Pill, Trinket, or an Enemy.');
  },
  onchange: function () {
    const connection = this.getInput('Input').connection.targetConnection;
    if (connection) {
      this.setEnabled(true);
    } else {
      this.setEnabled(false);
    }
  }
}

Blockly.JSON['room_spawn'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);

  if (params) {
    return {
      action: 'room_spawn',
      params
    }
  } else return;
}

Blockly.Blocks['default_room_spawn'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Random spawnable item.')
    this.setOutput(true, ['spawnable'])
  }
}

Blockly.JSON['default_room_spawn'] = (block) => {
  return {
    type: 'random',
    entity_id: -1
  }
}

Schema.registerAction('room_spawn', {
  "if": {
    "properties": {
      "action": {
        "const": "room_spawn"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "entity_id": {
            "type": "number"
          },
          "type": {
            "enum": [
              "active",
              "boss",
              "card",
              "collectible",
              "consumable",
              "enemy",
              "modifier_count",
              "monster",
              "passive",
              "pill",
              "random",
              "spawnable",
              "tier0active",
              "tier1active",
              "tier2active",
              "tier3active",
              "tier4active",
              "tier0passive",
              "tier1passive",
              "tier2passive",
              "tier3passive",
              "tier4passive",
              "trinket"
            ]
          },
          "from_param": {
            "type": "string",
            "minLength": 1,
          },
          "entity": {
            "properties": {
              "id": {
                "type": "number",
              },
              "subtype": {
                "type": "number",
              },
              "variant": {
                "type": "number",
              }
            },
            "additionalProperties": false,
          },
          "count": {
            "type": "number"
          }
        },
        "oneOf": [
          {
            "required": [
              "entity_id"
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
          {
            "required": [
              "entity"
            ],
          }
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params",
    ]
  }
});
